/**
 * Determine result field which is sent to MailerLite for weight test
 */
jQuery(document).ready(function ($) {
	if ($(".test-weight-form").length) {
		// Date
		const date = new Date();
		let month = date.getMonth() + 1;
		month = month < 10 ? `0${month}` : month;
		$(".form-date input").val(`${date.getFullYear()}-${month}-${date.getDate()}`);

		// Result
		const result = $(".form-result input");
		result.val("GOOD");

		$(".form-total input").on("change", function () {
			const value = $(this).val();

			if (value < 6) {
				result.val("GOOD");
			}
			else if (value >= 6 && value <= 10) {
				result.val("AVERAGE");
			}
			else {
				result.val("BAD");
			}
		});
	}
});
